import React, { useState } from "react";
import axios from "axios";
import { Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { buildWhatsAppLink, getContact } from "@/lib/site";
import { useContent } from "@/lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CourseLeadCard({ courseName, source }) {
  const { content } = useContent();
  const c = getContact(content);
  const [form, setForm] = useState({ name: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.phone.trim()) {
      toast.error("Name and phone are required.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { ...form, course: courseName, source });
      toast.success("Counsellor will reach out — opening WhatsApp now.");
      const text = `Hi Educators Institute! I'm ${form.name}. I want to know more about ${courseName}. Phone: ${form.phone}.${form.message ? " Note: " + form.message : ""}`;
      window.open(buildWhatsAppLink(text, c.whatsappRaw), "_blank", "noopener,noreferrer");
      setForm({ name: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Could not save your details. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid={`course-lead-form-${source}`}
      className="bg-white rounded-3xl p-6 md:p-8 border border-slate-100 shadow-xl"
    >
      <h3 className="font-rubik text-xl md:text-2xl font-bold text-[#0f172a]">
        Free {courseName} Career Plan
      </h3>
      <p className="mt-1 font-inter text-sm text-slate-600">15-minute call. Real counsellor. No spam.</p>

      <div className="mt-5 space-y-3">
        <input
          required
          data-testid={`course-lead-name-${source}`}
          value={form.name}
          onChange={(e) => update("name", e.target.value)}
          placeholder="Full name"
          className="w-full bg-[#f8fafc] rounded-xl border border-slate-200 px-4 py-3 font-inter text-sm text-slate-800 focus:outline-none focus:ring-4 focus:ring-[#73c3ff]/30 focus:border-[#73c3ff] transition"
        />
        <input
          required
          type="tel"
          inputMode="tel"
          data-testid={`course-lead-phone-${source}`}
          value={form.phone}
          onChange={(e) => update("phone", e.target.value)}
          placeholder="+91 90000 00000"
          className="w-full bg-[#f8fafc] rounded-xl border border-slate-200 px-4 py-3 font-inter text-sm text-slate-800 focus:outline-none focus:ring-4 focus:ring-[#73c3ff]/30 focus:border-[#73c3ff] transition"
        />
        <textarea
          data-testid={`course-lead-message-${source}`}
          value={form.message}
          onChange={(e) => update("message", e.target.value)}
          rows={2}
          placeholder="Your background or questions (optional)"
          className="w-full bg-[#f8fafc] rounded-xl border border-slate-200 px-4 py-3 font-inter text-sm text-slate-800 focus:outline-none focus:ring-4 focus:ring-[#73c3ff]/30 focus:border-[#73c3ff] transition resize-none"
        />
      </div>

      <button
        type="submit"
        disabled={loading}
        data-testid={`course-lead-submit-${source}`}
        className="mt-5 w-full inline-flex items-center justify-center gap-2 bg-[#002570] text-white hover:bg-[#001a52] disabled:opacity-70 rounded-full px-7 py-3.5 font-inter font-medium transition-all hover:shadow-xl"
      >
        {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Sending…</> : <>Get My Career Plan <ArrowRight className="w-4 h-4" /></>}
      </button>
    </form>
  );
}
